import { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'

import { routeName } from '~/@common/constants'
import authService from '~/@common/services/auth.service'
import { toastService } from '~/@common/services/toast.service'
import { FloatingLoader } from '~/@common/ui/(Loader)/FloatingLoader'
import { getEntrancePage } from '~/@common/utils/getEntrancePage'
import maxios from '~/@common/utils/maxios'

/**
 * AIEP(광주교육청 통합 로그인) 브릿지 페이지 (/aiep/bridge).
 *
 * ⚠️ /aiep/bridge 경로는 광주교육청/파트너사에 등록된 SAML 콜백 — 절대 변경 금지.
 * ⚠️ AIEP는 학생 전용 SSO. 응답이 STUDENT가 아니면 에러 처리.
 */
const AiepBridgePage = () => {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const code = searchParams.get('code')

  useEffect(() => {
    const handleError = (message = 'AIEP 로그인을 진행할 수 없습니다.\n다시 시도해주세요.') => {
      toastService.error(message)
      navigate(routeName.login, { replace: true })
    }

    if (!code) {
      handleError()
      return
    }

    ;(async () => {
      try {
        await authService.loginByAiep(code, true)
        // x-platform은 기본이 STUDENT지만, 다른 경로에서 변경되었을 수 있어 명시적으로 STUDENT로 고정
        maxios.defaults.headers.common['x-platform'] = 'STUDENT'
        navigate(getEntrancePage('STUDENT'), { replace: true })
      } catch (error) {
        if (error instanceof Error && error.message === 'STUDENT_ONLY') {
          handleError('학생 계정으로 로그인해주세요.')
          return
        }
        handleError()
      }
    })()
  }, [code, navigate])

  return <FloatingLoader />
}

export default AiepBridgePage
